import { getPayments } from './getPayments'
import { addPayments } from './addPayments'
import { continuePayment } from './continuePayment'
import { getPayCompany } from './getPayCompany'
import { getUrlAdministrator } from './getUrlAdministrator'
import { getPayBranchOffices } from './getPayBranchOffices'

export const Payments = {
    getPayments,
    continuePayment,
    getPayCompany,
    addPayments,
    getUrlAdministrator,
    getPayBranchOffices
}
